:host {
  display: block;

  .error {
    color: var(--av-color-danger);
  }

  av-asset {
    width: 100%;
  }

  app-display-capture {
    --av-container-round-width: calc(var(--av-font-size) * 3.3334); // 50px;
    --av-container-round-height: calc(var(--av-font-size) * 3.3334); // 50px;
  }

  .stream-full-screen {
    position: absolute;
    right: 4px;
    bottom: 4px;
    .av-button {
      display: inline;
    }
    &.stream-full-screen-top {
      bottom: auto;
      top: 4px;
    }
  }

  .stream-container {
    &.stream-container-outgoing .av-card-body {
      @include darken-on-hover;
      &:after {
        opacity: 1;
        visibility: visible;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    &.stream-container-bottom {
      &.stream-container-outgoing {
        .av-card {
          margin-bottom: calc(var(--av-container-round-width) - 10px);
          z-index: -1;
          margin-left: calc(var(--av-container-round-width) / 2);
        }
        // &:hover .av-card {
        //   margin-bottom: 0; // var(--av-container-round-width);
        // }
      }

      &.stream-container-incoming {
        .av-card {
          margin-bottom: calc($container-height + 10px);
        }
      }
    }
    &.stream-container-top {
      &.stream-container-outgoing {
        .av-card {
          margin-top: calc($container-height - 10px);
          // &:hover {
          //   margin-top: var(--av-container-round-width);
          // }
        }
      }
      &.stream-container-incoming {
        .av-card {
          margin-top: calc($container-height + 10px);
        }
      }
    }
    .av-card-body,
    .av-card-body > div {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    &.stream-container-loading {
      .av-card {
        width: 320px;
        height: 320px;
      }
      video {
        visibility: hidden;
        width: 0;
        opacity: 0;
        transition: opacity 0.2s ease-out;
      }
    }

    &.stream-container-ready {
      &.stream-container-incoming {
        .av-card {
          width: 70vw;
        }
      }
      &.stream-container-outgoing {
        .av-card {
          width: 180px;
        }
      }
      video {
        width: 100%;
        opacity: 1;
      }
    }
  }

  video {
    object-fit: cover;
    width: 100%;
    height: 100%;
    float: left;
  }

  .av-cobrowse-permission {
    height: $container-height;
    width: calc($container-width * 0.5);
    margin: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    av-asset {
      width: 25px;
    }
  }

  .av-cobrowse-action {
    transform: scale(0.8);
  }

  .av-cobrowse-permissions {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .title {
    margin-top: 0;
  }

  .av-card-ticket {
    margin-bottom: 150px;
    .av-card.av-card-center.av-card-floating.av-card-open {
      right: 50%;
      transform: translateX(50%) scale(1) !important;
    }

    .av-card-footer {
      text-align: right;
      padding: 0 15px 15px;
    }
  }

  .cobrowse-tray {
    position: absolute;
    padding: 5px;
    background-color: var(--av-background-color-tray);
    color: var(--av-color-tray);
    border-radius: $container-height;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 2px 8px fade-out(black, 0.8);
    z-index: 100010;
    min-width: 250px;
    height: var(--av-container-round-height);
    > div {
      display: flex;
      align-items: center;
      flex-direction: row;
    }

    &.cobrowse-tray-left {
      left: 0;
    }
    &.cobrowse-tray-right {
      right: 0;
    }
    &.cobrowse-tray-center {
      right: 50%;
      transform: translateX(50%);
    }
    &.cobrowse-tray-top {
      top: $container-height;
      margin-top: 10px;
    }
    &.cobrowse-tray-bottom {
      bottom: $container-height;
      margin-bottom: 10px;
    }

    &.cobrowse-tray-mobile {
      padding: 0;
      &.cobrowse-tray-left {
        left: $container-width;
        margin-left: 4px;
      }
      &.cobrowse-tray-right {
        right: $container-width;
        margin-right: 4px;
      }
      &.cobrowse-tray-top {
        top: 0;
        margin-top: 2.5px;
        &.cobrowse-tray-center {
          top: $container-height;
        }
      }
      &.cobrowse-tray-bottom {
        bottom: 0;
        margin-bottom: 2.5px;
        &.cobrowse-tray-center {
          bottom: $container-height;
        }
      }
    }

    av-switch {
      margin-left: 20px;
      margin-right: 3px;
    }
    av-asset {
      height: calc($container-height * 0.5);
      width: calc($container-width * 0.5);
      padding: 10px;
    }
    .cobrowse-tray-info {
      display: flex;
      flex-direction: column;
      padding-right: 12px;
      min-width: 180px;
      b {
        display: block;
        margin-bottom: 2px;
      }
      small,
      b {
        white-space: nowrap;
      }
    }
    .blink {
      @include animate(blink, 2s, infinite, linear);
      @include animation-blink();
    }
  }

  .pulse-danger {
    display: block;
    border-radius: 50%;
    @include animate(pulse-shadow, 2s, infinite, linear);
  }

  @include pulse-shadow(var(--av-color-danger));
}

.av-direction {
  direction: var(--av-direction);
}

.card-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
